// Mock data for VETRICH TECHNOLOGIES clone (frontend-only)

export const nav = [
  { label: 'Home', href: '#home' },
  { label: 'IT Services', href: '#services' },
  { label: 'Ayurveda', href: '#ayurveda' },
  { label: 'Electronics', href: '#divisions' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

export const heroStats = [
  { value: 'ISO\n9001:2015', label: 'Certified Company' },
  { value: '2', label: 'Business Divisions' },
  { value: '12+', label: 'Sectors Served' },
  { value: '100%', label: 'Client-Centric' },
];

export const marqueeItems = [
  'eTENDERS', 'DIGITAL SIGNATURE', 'ISO CERTIFICATION', 'STARTUP REGISTRATION',
  'PWD REGISTRATION', 'IT SOLUTIONS', 'ELECTRONICS',
];

export const divisions = [
  {
    icon: 'Monitor',
    title: 'IT Services & Consultancy',
    desc: 'eTenders, Digital Signatures, ISO certification, startup & PWD registration and custom IT solutions.',
  },
  {
    icon: 'Cpu',
    title: 'Electronics',
    desc: 'Our own brand of quality electronics and smart accessories — buds, speakers, power banks and more, launching soon.',
  },
];

export const missionVision = [
  {
    icon: 'Target',
    title: 'Our Mission',
    desc: 'To provide reliable, innovative and affordable digital solutions that empower businesses, contractors, startups and organizations to achieve sustainable growth while ensuring complete compliance with government and industry standards.',
  },
  {
    icon: 'Eye',
    title: 'Our Vision',
    desc: 'To become one of India\u2019s most trusted technology and consultancy companies by delivering excellence in eTender services, digital transformation, business compliance and IT solutions.',
  },
];

export const services = [
  { num: '01', title: 'eTender Services', desc: 'End-to-end support for government & private tenders.' },
  { num: '02', title: 'Digital Signature Certificate (DSC)', desc: 'DSC services for individuals, businesses & contractors.' },
  { num: '03', title: 'ISO Certification Consultancy', desc: 'Internationally recognized ISO certifications, end to end.' },
  { num: '04', title: 'Startup Registration', desc: 'Launch your business with confidence.' },
  { num: '05', title: 'PWD Registration Consultancy', desc: 'Contractor registration with PWD & government departments.' },
  { num: '06', title: 'IT Services', desc: 'Innovative technology solutions for productivity & efficiency.' },
  { num: '07', title: 'Business Consultancy', desc: 'Professional guidance for registration & compliance.' },
];

export const offerings = [
  { name: 'User Registration Maharashtra Tenders', price: '₹1,000' },
  { name: 'Online QR Based Bid Capacity PWD Certification', price: '₹8,000' },
  { name: 'eTender Publish Training', price: '₹25,000' },
  { name: 'eTender Training Submission', price: '₹20,000' },
  { name: 'Railway Registration Consultation', price: '₹5,000' },
  { name: 'EPASS Token', price: '₹800' },
  { name: 'eTender Submission', price: '₹2,000' },
  { name: 'MSME Certification Consultation', price: '₹2,000' },
  { name: 'GEM Registration Consultation', price: '₹5,000' },
  { name: 'Digital Signature Certificate (Sign + Encrypt)', price: '₹4,000' },
  { name: 'Digital Signature Certificate (Sign only)', price: '₹2,500' },
  { name: 'ISO 9001:2015 Consultation', price: '₹8,000' },
  { name: 'Startup Registration Consultation', price: '₹20,000' },
];

export const ayurvedaProducts = [
  {
    tag: 'IMMUNITY',
    name: 'Ashwagandha Wellness Capsules',
    desc: 'Pure Ashwagandha root extract for stress relief, energy and immunity. 60 veg capsules.',
    price: '₹499',
    image: 'https://images.unsplash.com/photo-1763668331599-487470fb85b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxheXVydmVkYSUyMHN1cHBsZW1lbnQlMjBib3R0bGV8ZW58MHx8fHwxNzg3NzMzODc4fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    tag: 'SKINCARE',
    name: 'Radiance Beauty Serum',
    desc: 'Natural glow serum with saffron and rose. Suits all skin types. 30ml.',
    price: '₹749',
    image: 'https://images.unsplash.com/photo-1741896135512-084b251887f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxoZXJiYWwlMjBzZXJ1bXxlbnwwfHx8fDE3ODc3MzM4Nzh8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    tag: 'DIGESTION',
    name: 'Herbal Digestive Tonic',
    desc: 'Ayurvedic tonic blending 12 herbs to support healthy digestion. 200ml.',
    price: '₹349',
    image: 'https://images.unsplash.com/photo-1734607404574-df50e1839d6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxheXVydmVkYSUyMHN1cHBsZW1lbnQlMjBib3R0bGV8ZW58MHx8fHwxNzg3NzMzODc4fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    tag: 'GIFTING',
    name: 'Herbal Care Gift Box',
    desc: 'Curated wellness gift box with 4 bestselling herbal products.',
    price: '₹1,299',
    image: 'https://images.unsplash.com/photo-1707944145479-12755f0434d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHx3ZWxsbmVzcyUyMGdpZnQlMjBib3h8ZW58MHx8fHwxNzg3NzMzODc4fDA&ixlib=rb-4.1.0&q=85',
  },
];

export const whyChoose = [
  'Professional & Experienced Team',
  'Complete End-to-End Consultancy',
  'Transparent Process',
  'Accurate Documentation',
  'Fast Response & Timely Service',
  'Reliable Technical Support',
  'Customer-Centric Approach',
  'Affordable Service Packages',
  'Secure & Confidential Handling',
];

export const industries = [
  'Government Contractors', 'Construction Companies', 'Engineering Firms',
  'Infrastructure Companies', 'Manufacturers', 'Traders', 'MSMEs',
  'Startups', 'Educational Institutions', 'Healthcare Organizations',
  'Corporate Businesses', 'Professional Service Providers',
];

export const contactInfo = {
  phone: '+91 99212 43333',
  email: 'vetrichtechnologies@gmail.com',
  location: 'Maharashtra, India',
  whatsapp: 'https://wa.me/919921243333',
};
